import React, { useEffect, useState, useMemo } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import FormWrapper from "../FormWrapper";
import {
  getProvidersList,
  getProviderDetailById,
} from "../../../redux/providersSlice";
import { useToastMessage } from "../../../components/ToastMessage/ToastMessage";
import { Tab, TabList, Toaster } from "@fluentui/react-components";
import { FormLoader } from "../../../components/Loader/FormLoader";
import { TableListLoader } from "../../../components/Loader/TableListLoader";
import BulkValuation from "../BulkValuation/bulkValuation";
import ListWrapper from "../ListWrapper";
import { configFm } from "../../../types";
import { convertStringToArray } from "../../../utils";
import { debounce } from "lodash";
const FORM_CONTEXT = "MASTER_SETTINGS_PROVIDERS";
const API_BASE_PATH = "/system-manager/providers";

function ProviderDetailPage() {
  const { itemId, action } = useParams();
  const location = useLocation();
  const { showToast, toasterId } = useToastMessage();
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const { activeItem, list, loading, activeItemloading, count } = useSelector(
    (state: RootState) => state.providers
  );
  const [selectedProvider, setSelectedProvider] = useState({});
  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const [configForm, setConfigForm] = useState<configFm>();
  const [currentRecord, setCurrentRecord] = useState(1);
  const [activeTab, setActiveTab] = useState("tab1");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [globalFilter, setGlobalFilter] = useState("");
  const handleTabChange = (event: any, data: any) => {
    setActiveTab(data.value);
  };
  const debouncedFetch = useMemo(
    () =>
      debounce((filter: string) => {
        if (filter && filter.length >= 2) {
          setGlobalFilter(filter);
        }
      }, 300),
    []
  );
  useEffect(() => {
    dispatch(
      getProvidersList({
        page: pagination.pageIndex + 1,
        limit: pagination.pageSize,
        search: globalFilter,
      })
    );
  }, [dispatch, pagination.pageIndex, pagination.pageSize, globalFilter]);
  useEffect(() => {
    if (list.length > 0 && itemId) {
      const itemInList = list.find((item) => item.id === itemId);
      if (!itemInList) {
        if (list[0]?.id) {
          dispatch(getProviderDetailById(list[0].id));
          navigate(`${API_BASE_PATH}/${list[0].id}/${action || "view"}`);
        }
      } else {
        dispatch(getProviderDetailById(itemId));
      }
    }
  }, [list, itemId, dispatch, pagination.pageSize]);

  useEffect(() => {
    if (list.length > 0 && !itemId && !action) {
      navigate(`${API_BASE_PATH}`);
    }
  }, [list, itemId, action, navigate]);
  useEffect(() => {
    if (
      formSettingsObj?.systemAdmin &&
      formSettingsObj.systemAdmin.formConfig !== undefined
    ) {
      let configObj = formSettingsObj.systemAdmin.formConfig.find(
        (item: any) => item.context === FORM_CONTEXT
      );
      if (configObj) {
        setConfigForm(configObj);
      }
    }
  }, [formSettingsObj]);

  const loadData = async (
    dispatch: AppDispatch,
    id?: string
  ): Promise<void> => {
    await dispatch(
      getProvidersList({
        page: pagination.pageIndex + 1,
        limit: pagination.pageSize,
        search: globalFilter,
      })
    );
    if (id) {
      await dispatch(getProviderDetailById(id));
    }
  };
  const hasListItems = useMemo(() => list.length > 0, [list]);

  const handleCancel = () => {
    setActiveTab("tab1");
  };
  return (
    <>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <TabList selectedValue={activeTab} onTabSelect={handleTabChange}>
        {!convertStringToArray(process.env.REACT_APP_HIDE_CTA_BUTTON).includes(
          "sm_providerDetails"
        ) ? (
          <Tab value="tab1">Provider Details</Tab>
        ) : (
          ""
        )}
        {!convertStringToArray(process.env.REACT_APP_HIDE_CTA_BUTTON).includes(
          "sm_bulk_valuation"
        ) ? (
          <Tab value="tab2">Bulk Valuation</Tab>
        ) : (
          ""
        )}
      </TabList>
      <div className="admin_container_flex">
        {action &&
          (activeItemloading ? (
            <FormLoader />
          ) : (
            <>
              {activeTab === "tab1" && (
                <FormWrapper
                  dataList={list}
                  context={FORM_CONTEXT}
                  reloadData={loadData}
                  selectedRowItem={activeItem}
                  config={configForm}
                  action={action || "view"}
                  apiPath={API_BASE_PATH}
                  notify={showToast}
                  activeRow={currentRecord}
                />
              )}
              {activeTab === "tab2" && (
                <BulkValuation
                  selectedProvider={activeItem}
                  handleCancel={handleCancel}
                />
              )}
            </>
          ))}

        {loading ? (
          <TableListLoader rows={8} columns={6} />
        ) : (
          hasListItems &&
          action &&
          list.length > 0 && (
            <ListWrapper
              data={list}
              context={FORM_CONTEXT}
              selectedRowItem={activeItem}
              onRowAction={(action, row) =>
                navigate(`${API_BASE_PATH}/${row?.id}/${action || "view"}`)
              }
              currentRecord={(index) => setCurrentRecord(index)}
              pagination={pagination}
              setPagination={setPagination}
              globalFilter={globalFilter}
              setGlobalFilter={debouncedFetch}
              rowCount={count}
            />
          )
        )}
      </div>
    </>
  );
}

export default ProviderDetailPage;
